// ─── theme.js ─────────────────────────────────────────────────────────────────
// Wayne Enterprises Brand Themes — Dark & Light
// ──────────────────────────────────────────────────────────────────────────────

const base = {
  // ─── Brand ────────────────────────────────────────────────────────────────
  primary:          "#7D1525",
  primarySub:       "#8B1A2A",
  primaryGlow:      "rgba(125,21,37,0.15)",
  gold:             "#C9A84C",
  goldLight:        "#F0D080",
  goldDark:         "#8B6914",
  goldGlow:         "rgba(201,168,76,0.20)",
  goldGradient:     "linear-gradient(135deg, #8B6914 0%, #F0D080 35%, #C9A84C 55%, #F0D080 75%, #8B6914 100%)",
  goldGradientText: "linear-gradient(135deg, #C9A84C 0%, #F0D080 40%, #C9A84C 60%, #8B6914 100%)",
  positive:         "#4A9B6F",
  rubyLight:        "#C0392B",
  fontDisplay:      "'Montserrat', sans-serif",
  fontBody:         "'Montserrat', sans-serif",
  fontMono:         "'JetBrains Mono', monospace",
  weightDisplay:    600,
  weightSub:        500,
  weightBody:       400,
};

export const darkTheme = {
  ...base,
  mode:         "dark",
  bg:           "#0A0A0A",
  bgDeep:       "#050505",
  surface:      "#111111",
  surfaceHigh:  "#1A1A1A",
  textPrimary:  "#F0E6D0",
  textSilver:   "#C8B99A",
  textMuted:    "#6B5D4F",
  border:       "#1E1A14",
  borderLight:  "#2A2318",
  borderGold:   "#3D2E0A",
  purple:       "#7D1525",
  purpleLight:  "#C9A84C",
  purpleDim:    "#3D0A12",
  purpleGlow:   "rgba(125,21,37,0.15)",

  // Nav specific
  navBg:        "#0D0D0D",
  navBorder:    "#1E1A14",
  navText:      "#6B5D4F",
  navActive:    "#C9A84C",
  navActiveBg:  "linear-gradient(90deg, rgba(125,21,37,0.15), transparent)",
  navActiveBorder: "#7D1525",

  // Tab underline
  tabUnderline: "#C9A84C",
};

export const lightTheme = {
  ...base,
  mode:         "light",
  bg:           "#F2EFE9",
  bgDeep:       "#E8E3DB",
  surface:      "#FFFFFF",
  surfaceHigh:  "#F8F5F0",
  textPrimary:  "#1A1210",
  textSilver:   "#3D3028",
  textMuted:    "#7A6E64",
  border:       "#D4C9BC",
  borderLight:  "#E0D8CE",
  borderGold:   "#C9A84C",
  purple:       "#7D1525",
  purpleLight:  "#8B1A2A",
  purpleDim:    "#F5E8EA",
  purpleGlow:   "rgba(125,21,37,0.08)",

  // Nav specific
  navBg:        "#1A1210",
  navBorder:    "#2A1E18",
  navText:      "#C8B99A",
  navActive:    "#C9A84C",
  navActiveBg:  "linear-gradient(90deg, rgba(201,168,76,0.15), transparent)",
  navActiveBorder: "#C9A84C",

  // Tab underline
  tabUnderline: "#C9A84C",
};

export default darkTheme;